<template>
    <Button v-if="podeCriarAlterarOuExcluirAcao" class="ml-2" icon="pi pi-plus" label="Adicionar" @click="showDialog()" />

    <Dialog v-model:visible="openDialog" no-close-on-backdrop :style="{ width: '50vw' }" :maximizable="false">
        <template #header>
            <h3>Cadastro - Ações</h3>
        </template>

        <div class="formgrid grid p-fluid">
            <div class="field col-12">
                <label class="required">Descrição</label>
                <InputText type="text" v-model="descricaoAcao" />
            </div>
        </div>
        <div class="formgrid grid p-fluid">
            <div class="field col-6">
                <label class="required">Eixo</label>
                <Dropdown v-model="eixo" :filter="true" :options="comboEixos" optionLabel="label" optionValue="key" @change="selectSubEixos" />
            </div>
            <div class="field col-6">
                <label class="required">Sub Eixos</label>
                <Dropdown v-model="subEixo" :filter="true" :options="filteredSubEixos" optionLabel="label" optionValue="key" />
            </div>
        </div>
        <div class="formgrid grid p-fluid">
            <!-- <div class="field col-4">
                <label>Contrapartida Financeira do Parceiro</label>
                <div class="p-inputgroup">
                    <InputNumber v-model="valorCliente" mode="decimal" :minFractionDigits="2" />
                </div>
            </div> -->
            <div class="field col-4">
                <label>Valor Sebrae</label>
                <div class="p-inputgroup">
                    <InputNumber v-model="valorSebrae" mode="decimal" :minFractionDigits="2" />
                </div>
            </div>
            <div class="field col-4">
                <label>Valor Total</label>
                <div class="p-inputgroup">
                    <InputNumber v-model="valorTotal" mode="decimal" :minFractionDigits="2" disabled="true" />
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Salvar" @click="salvar()" :disabled="!isFormValid" />
            <Button label="Fechar" autofocus @click="closeDialog()" />
        </template>
    </Dialog>
</template>

<script>
import Services from '../../service.js';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

export default {
    props: {
        parceria: {
            type: Object,
        },

        operacao: {
            type: String,
            default: 'PARCERIA',
        },

        parceriaAditivo: {
            type: Object,
        },

        show: {
            type: Boolean,
            default: false,
        },

        defaultValue: {
            type: Object,
        },
    },

    emits: ['atualizarLista', 'close'],

    validations() {
        return {
            descricaoAcao: { required },
            eixo: { required },
        };
    },

    setup() {
        return { v$: useVuelidate() };
    },

    data() {
        return {
            descricaoAcao: null,
            // valorCliente: null,
            valorSebrae: null,
            valorTotal: null,
            display: 0,
            acao: null,
            id: 0,
            eixo: null,
            subEixo: null,
            comboEixos: [
                {
                    key: 7,
                    label: 'CIDADE EMPREENDEDORA',
                },
                {
                    key: 8,
                    label: 'EDUCAÇÃO EMPREENDEDORA',
                },
                {
                    key: 9,
                    label: 'STARTUP PE',
                },
                {
                    key: 10,
                    label: 'COMPETITIVIDADE E MERCADOS',
                },
            ],
            comboSubEixos: {
                comboSubEixosCidadeEmpreendedora: [
                    {
                        key: 11,
                        label: 'Gestão e Políticas Públicas',
                    },
                    {
                        key: 12,
                        label: 'Lideranças Locais e Governança',
                    },
                    {
                        key: 13,
                        label: 'Simplificação',
                    },
                    {
                        key: 14,
                        label: 'Sala do Empreendedor',
                    },
                    {
                        key: 15,
                        label: 'Compras Públicas e acesso a crédito',
                    },
                    {
                        key: 16,
                        label: 'Empreendedorismo na Escola',
                    },
                    {
                        key: 17,
                        label: 'Inclusão Socioprodutiva',
                    },
                    {
                        key: 18,
                        label: 'Identidade, Vocações e Mercados',
                    },
                    {
                        key: 19,
                        label: 'Inovação',
                    },
                    {
                        key: 20,
                        label: 'Resiliência Climática e Sustentabilidade',
                    },
                ],

                comboSubEixosEducacaoEmpreendedora: [
                    {
                        key: 21,
                        label: 'Ensino Fundamental',
                    },
                    {
                        key: 22,
                        label: 'Ensino Médio',
                    },
                    {
                        key: 23,
                        label: 'Educação Profissional',
                    },
                    {
                        key: 24,
                        label: 'Educação Superior',
                    },
                    {
                        key: 25,
                        label: 'Profissionais da Educação',
                    },
                ],
                comboSubEixosStartupPE: [
                    {
                        key: 26,
                        label: 'Ecossistemas de Inovação',
                    },
                    {
                        key: 27,
                        label: 'Fomento a Startups',
                    },
                    {
                        key: 28,
                        label: 'Acesso a Mercados',
                    },
                    {
                        key: 29,
                        label: 'Engajamento e Eventos Mobilizadores',
                    },
                ],
                comboSubEixosCompetitividadeEMercados: [
                    {
                        key: 30,
                        label: 'Sebraetec – Inovação',
                    },
                    {
                        key: 31,
                        label: 'Edital de Mercado (Instrutoria e/ou Consultoria)',
                    },
                    {
                        key: 32,
                        label: 'Acesso a Mercados (Feiras, Missões/Caravanas, Rodadas)',
                    },
                    {
                        key: 33,
                        label: 'Plural',
                    },
                    {
                        key: 34,
                        label: 'Desenvolvimento Empresarial (Instrutoria e/ou Consultoria)',
                    },
                ],
            },
        };
    },

    methods: {
        showDialog() {
            this.display = true;
            this.limpar();
        },

        limpar() {
            this.descricaoAcao = '';
            // this.valorCliente = 0;
            this.valorSebrae = 0;
            this.valorTotal = 0;
            this.eixo = null;
            this.subEixo = null;
        },

        closeDialog() {
            this.$emit('close');
            this.display = false;
        },

        salvar() {
            if (this.subEixo == null) {
                this.subEixo = 0;
            }
            this.acao = {
                descricaoAcao: this.descricaoAcao,
                // valorCliente: this.valorCliente,
                valorSebrae: this.valorSebrae,
                valorTotal: this.valorTotal,
                eixo: this.eixo,
                subEixo: this.subEixo,
            };
            this.$store.dispatch('addRequest');
            if (this.id != 0) {
                this.acao.acaoId = this.id;
            }
            this.acao.idParceria = this.parceria.id;
            Services.InserirOuAlterarAcaoParceria(this.id, this.acao).then((response) => {
                if (response && response.success) {
                    this.$emit('atualizarLista');
                }
                this.closeDialog();
                this.$store.dispatch('removeRequest');
                this.limpar();
            });
        },

        selectSubEixos() {
            switch (this.eixo) {
                case 7:
                    this.filteredSubEixos = this.comboSubEixos.comboSubEixosCidadeEmpreendedora;
                    break;
                case 8:
                    this.filteredSubEixos = this.comboSubEixos.comboSubEixosEducacaoEmpreendedora;
                    break;
                case 9:
                    this.filteredSubEixos = this.comboSubEixos.comboSubEixosStartupPE;
                    break;
                case 10:
                    this.filteredSubEixos = this.comboSubEixos.comboSubEixosCompetitividadeEMercados;
                    break;
                default:
                    this.filteredSubEixos = [];
            }
        },
    },

    computed: {
        openDialog() {
            return this.show || this.display;
        },
        podeCriarAlterarOuExcluirAcao() {
            return this.parceria.aditivoPendente || this.parceria?.status === 0;
        },
        isFormValid() {
            return this.descricaoAcao !== null && this.eixo !== null && this.subEixo !== null;
        },
    },

    watch: {
        defaultValue() {
            this.descricaoAcao = this.defaultValue?.descricaoAcao;
            // this.valorCliente = this.defaultValue?.valorCliente;
            this.valorSebrae = this.defaultValue?.valorSebrae;
            this.valorTotal = this.defaultValue?.valorTotal;
            this.eixo = this.defaultValue?.eixo;
            this.subEixo = this.defaultValue?.subEixo;
            this.id = this.defaultValue?.acaoId;
            this.idParceria = this.defaultValue?.idParceria;
        },
        // valorCliente()
        // {
        //     if(this.valorCliente != null || this.valorCliente != 0)
        //     {
        //         this.valorTotal = 0;
        //         this.valorTotal = this.valorCliente + this.valorSebrae;
        //     }
        // },
        valorSebrae() {
            if (this.valorSebrae != null || this.valorSebrae != 0) {
                this.valorTotal = 0;
                this.valorTotal = this.valorSebrae;
            }
        },
    },
};
</script>
